import { useEffect, useRef } from "react";

export const Overline = ({ children, light = false }) => (
  <p className={`font-mono text-xs font-semibold uppercase tracking-[0.15em] ${light ? "text-[#8FC690]" : "text-[#233D25]"}`}>
    {children}
  </p>
);

// Content is always visible in the HTML; the reveal is only an enhancement:
// we pre-hide an element just once, only if it is below the fold, and always
// force-reveal it after a short fallback — reduced-motion users never see it hidden.
export const Reveal = ({ children, delay = 0, y = 32, className = "" }) => {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el || typeof IntersectionObserver === "undefined") return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    if (el.getBoundingClientRect().top <= window.innerHeight) return;

    el.style.opacity = "0";
    el.style.transform = `translateY(${y}px)`;
    el.style.willChange = "opacity, transform";
    let raf;
    const show = () => {
      el.style.transition = `opacity 0.9s cubic-bezier(0.22,1,0.36,1) ${delay}s, transform 0.9s cubic-bezier(0.22,1,0.36,1) ${delay}s`;
      el.style.opacity = "1";
      el.style.transform = "none";
    };
    const io = new IntersectionObserver(
      (entries) => {
        if (entries.some((e) => e.isIntersecting)) {
          raf = requestAnimationFrame(show);
          io.disconnect();
          clearTimeout(fallback);
        }
      },
      { rootMargin: "0px 0px -10% 0px" }
    );
    const fallback = setTimeout(() => {
      show();
      io.disconnect();
    }, 2000);
    io.observe(el);
    return () => {
      io.disconnect();
      clearTimeout(fallback);
      if (raf) cancelAnimationFrame(raf);
    };
  }, [delay, y]);

  return (
    <div ref={ref} className={className}>
      {children}
    </div>
  );
};
